import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import $axios from "../../api/accessories";
import { $api } from "../../api/api";
interface  translationsData {
  [key: string]: string; // Dinamik açarları və onların dəyərlərini "string" olaraq qəbul edirik.
}

interface translationsState {
  loading: boolean;
  data: translationsData;
  error: string;
  lang: string;
}

const initialState: translationsState = {
  loading: false,
  data: {},
  error: "",
  lang: "",
};

export const getTranslations = createAsyncThunk<translationsData, string | void, { state: any }>(
  "getTranslations",
  async (lang) => {
    const targetLang = (typeof lang === "string" && lang) ? lang : (localStorage.getItem("lang") || "az");
    const response = await $axios.get($api("translations"), {
      headers: { "Accept-Language": targetLang.toLowerCase() },
    });
    return response.data.data;
  },
  {
    condition: (lang, { getState }) => {
      const { translations } = getState();
      if (translations?.loading) {
        return false;
      }
      const targetLang = (typeof lang === "string" && lang ? lang : (localStorage.getItem("lang") || "az")).toLowerCase();
      if (translations?.lang === targetLang && Object.keys(translations?.data || {}).length > 0) {
        return false;
      }
    },
  }
);

export const getTranslationsSlice = createSlice({
  name: "translations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTranslations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTranslations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lang = ((action.meta.arg as string) || localStorage.getItem("lang") || "az").toLowerCase();
      })
      .addCase(getTranslations.rejected, (state) => {
        state.loading = false;
        state.error = "data not found";
      });
  },
});

export default getTranslationsSlice.reducer;
